var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33692 8.76923H17.3061M7.33692 8.76923C6.81995 8.76923 6.56082 8.76923 6.36336 8.86984C6.18967 8.95834 6.04856 9.09945 5.96006 9.27314C5.85945 9.47059 5.85945 9.72927 5.85945 10.2462V15.0462C5.85945 16.0802 5.85945 16.5972 6.06067 16.9922C6.23767 17.3395 6.51989 17.622 6.86727 17.799C7.26179 18 7.77852 18 8.81045 18H15.8312C16.8631 18 17.3791 18 17.7736 17.799C18.121 17.622 18.4045 17.3395 18.5815 16.9921C18.7825 16.5976 18.7825 16.0815 18.7825 15.0496V10.2379C18.7825 9.72647 18.7825 9.46952 18.6825 9.27314C18.594 9.09945 18.4522 8.95834 18.2785 8.86984C18.0811 8.76923 17.8231 8.76923 17.3061 8.76923M7.33692 8.76923H5.83666C5.05288 8.76923 4.66122 8.76923 4.43878 8.63221C4.14193 8.44936 3.97362 8.11458 4.00338 7.76721C4.0257 7.50668 4.25899 7.19159 4.72634 6.56067C4.86151 6.37819 4.92912 6.28693 5.01185 6.21725C5.12217 6.12434 5.25308 6.05836 5.39341 6.02501C5.49865 6 5.61161 6 5.83872 6H18.8028C19.0299 6 19.1431 6 19.2484 6.02501C19.3887 6.05836 19.5196 6.12434 19.6299 6.21725C19.7126 6.28693 19.7805 6.37776 19.9156 6.56025C20.383 7.19116 20.6167 7.50662 20.639 7.76715C20.6687 8.11453 20.4998 8.44936 20.203 8.63221C19.9805 8.76923 19.5879 8.76923 18.8042 8.76923H17.3061M10.4748 13.3846H14.1671",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.2d75ec15f5867b0626fcc857176d250e.svg";
export { ForwardRef as ReactComponent };